import { configureStore } from "@reduxjs/toolkit";
import userReducer        from "../slice/user/userSlice";
import categoryReducer    from "../slice/category/categorySlice";
import productReducer     from "../slice/product/productSlice";
import cartReducer        from "../slice/cart/cartSlice";
import adminUserReducer   from "../slice/adminUser/adminUser";
import checkoutReducer    from "../slice/checkout/checkoutSlice";
import orderReducer       from "../slice/order/orderSlice";
import searchReducer      from "../slice/search/searchSlice";
import bannerReducer      from "../slice/banner/bannerSlice";
import addressReducer     from "../slice/address/addressSlice";
import vendorDashboardReducer from "../slice/dashboard/Dashboardslice"; 
import offerReducer       from "../slice/offer/offerslice";

import locationReducer       from "../slice/location/locationslice";
import customerReducer       from "../slice/customer/customerslice";
import ratingReducer       from "../slice/rating/ratingSlice";
import vendorReducer from "../slice/vendor/vendorSlice"; 
import vendorReportReducer from "../slice/vendor/vendorSlice";
import vendormanagementReducer from "../slice/vendor/vendormanagementSlice";
import payoutReducer from "../slice/payout/payoutSlice";
import dashboardReducer from "../slice/dashboard/Dashboardslice";
import reportsReducer from "../slice/reports/Reportslice";
import vendorNotificationReducer from "../slice/Notification/vendorNotificationSlice";
import userNotificationReducer from "../slice/Notification/userNotificationSlice";
export const store = configureStore({
  reducer: {
  
    user:        userReducer,
    category:    categoryReducer,
    product:     productReducer,
    vendorDashboard: vendorDashboardReducer, 
    cart:        cartReducer,
    adminUser:   adminUserReducer,
    checkout:    checkoutReducer,
    orders:      orderReducer,
    dashboard:   dashboardReducer,
    search:      searchReducer,
    banner:      bannerReducer,
    address:     addressReducer,
    offer:       offerReducer,
    location:    locationReducer,
    customer:    customerReducer,
     dashboard: dashboardReducer,
    payout: payoutReducer,
    rating: ratingReducer,
    vendor: vendorReducer,
    vendorReport: vendorReportReducer,  
    vendormanagement: vendormanagementReducer,  
    reports: reportsReducer,
      vendorNotification: vendorNotificationReducer,
    userNotification: userNotificationReducer
  },
});